import { BudgetExpensesForm } from './BudgetExpensesForm';

export const BudgetOnboardingFixedExpenses = () => (
    <BudgetExpensesForm budgetPurpose="fixed" />
);
